module.exports = __webpack_public_path__ + "img/artboard.97bc8bf6.webp";